/*global $*/

/**
 * Функция для получения правильной формы слова в зависимости от числительного
 * @param {Number} number - число
 * @param {Object} words - объект с формами слов
 * @param {String} words.one - склонение слова для единичного экземпляра (1 элемент)
 * @param {String} words.few - склонение слова для малого количества экземпляров (2 элементА)
 * @param {String} words.many - склонение слова для большого количества экземпляров (5 элементОВ)
 * @returns {*}
 */
var pluralize = function (number, words) {
    'use strict';

    number = Math.abs(number);

    if (number % 100 >= 5 && number % 100 <= 20) {
        return words.many;
    } else if (number % 10 === 1) {
        return words.one;
    } else if (number % 10 < 5) {
        return words.few;
    }
    return words.many;
};

$(document).ready(function () {
    'use strict';
    $('.js-simple-tabs').each(function() {
        var $t = $(this);
        $t.data('simpleTabs', $t.simpleTabs());
    });

    $('.js-photo-tab-init-slick').each(function () {
        var $photoTab = $(this);
        $photoTab.on('click', function () {
            rfs.albumSlider.init();
            $('#broadcastAlbums').bind('afterShow', function() {
                rfs.albumSlider.init();
            });
        });
    });

    /**
     * инициализация свайпера
     */
    var lightSwiper = '.js-swiper-fc';
    $(lightSwiper).each(function () {
        $(this).data('swiperSimple', $(this).swiperSimple({}, lightSwiper));
    });

    /**
     * инициализация свайпера новостей с пагинацией
     */
    var lightSwiperWithPagination = '.js-swiper-main-news';
    $(lightSwiperWithPagination).each(function () {
        var currentResponse = null;
        var currentPagination = 1;
        var isLoading = false;
        var swiperInstance = $(this).swiperSimple({}, this);
        $(this).data('swiperSimple', swiperInstance);
        var currentSlidesLength = $(this).find('.js-swiper-slide').length;

        var setCurrentSlidesCounts = function () {
            currentSlidesLength = $(this).find('.js-swiper-slide').length;
        };

        var fetchNews = function () {
            if (isLoading) {
                return;
            }

            isLoading = true;

            $.ajax('/load-more-news?' + 'page=' + currentPagination, {
                method: 'get',
            }).done(function (response) {
                console.log(response);

                currentResponse = response;
                isLoading = false;


                if (!swiperInstance) {
                    return;
                }

                swiperInstance.appendSlide(currentResponse.items);
                setCurrentSlidesCounts();
            });
        };

        swiperInstance.on('slideChange', function () {
            if (currentResponse && !currentResponse.nextPageExists) {
                return;
            }

            var isNeedLoading = swiperInstance.activeIndex >= ((currentSlidesLength - 1) / 2);

            if (!isNeedLoading || isLoading) {
                return;
            }

            currentPagination = currentPagination + 1;
            fetchNews();
        });
    });

    var bigSwiper = '.js-swiper-big-indents';
    $(bigSwiper).each(function (index, target) {
        var navigation = {
            nextEl: $(this).find('.js-swiper-next').get(0) || '.js-swiper-next',
            prevEl: $(this).find('.js-swiper-prev').get(0) || '.js-swiper-prev',
        };

        var settings = {
            mobileMin: 70,
            tabletMax: 48,
            desktopMin: 72,
            desktopMax: 72,
            navigation: navigation,
        };

        var swiperWrapper = $(target).find('.swiper').get(0);

        if (!swiperWrapper) {
            return;
        }

        $(this).data('swiperSimple', $(this).swiperSimple(settings, swiperWrapper));
    });

    // Инициализация новостей в личном кабинете болельщика
    $('.js-news-list-wrap').each(function () {
        var $t = $(this);
        if (typeof $t.data('news-list') === 'undefined') {
            $t.data('news-list', $t.newsList());
        }
    });

    // Инпут, позволяющий вводить только цифры
    $('input.js-numbers-only').each(function () {
        var $t = $(this);

        $(document).ready(function () {
            // если код страны не пустой - поставить "+" перед значением
            if ($t.hasClass('js-country-code') && $t.val()) {
                $t.val('+' + $t.val().replace(/[^0-9]/gi, ''));
            }
        });

        $t.on('focus input', function() {
            // убираем из value всё, кроме цифр
            var cleanValue = $t.val().replace(/[^0-9]/gi, '');
            $t.val(($t.hasClass('js-country-code') ? '+' : '') + cleanValue); // добавляем "+" перед значением, если это код страны
        });
    });

    // Лоадер и отключениие для кнопок отправки формы
    $('.js-disable-on-submit').each(function () {
        var $btn = $(this);
        var $form = $btn.closest('form');
        var $coverContainer = $btn.closest('.js-cover-on-submit');
        var $loader = $('<span>', {
            class: 'loader',
            append: function () {
                var circlesArray = [];
                for (var i = 0; i < 8; i++) {
                    circlesArray.push($('<span>', {
                        class: 'circle'
                    }));
                }
                return circlesArray;
            }
        });

        $btn.append($loader.clone());
        if ($coverContainer.length) {
            $coverContainer.append($loader.clone());
        }

        $form.on('beforeSubmit', function() {
            $btn.prop('disabled', true);
            if ($coverContainer.length) {
                $coverContainer.addClass('cover');
            }
        });
        $form.on('submit', function() {
            $btn.prop('disabled', true);
            if ($coverContainer.length) {
                $coverContainer.addClass('cover');
            }
        });
        $form.on('beforeValidate', function() {
            $btn.prop('disabled', true);
            if ($coverContainer.length) {
                $coverContainer.addClass('cover');
            }
        });
        $form.on('afterValidate', function() {
            $btn.prop('disabled', false);
            if ($coverContainer.length) {
                $coverContainer.removeClass('cover');
            }
        });
    });

    $(document).on('input', '.js-textarea-autosize', function () {
        var self = this;
        $(self)
            .css('height', '')
            .css('height', self.scrollHeight);
    });

    $('.js-count-chars-container').each(function () {
        var $container = $(this);
        var $input = $container.find('.js-count-chars-input');
        var $counter = $container.find('.js-char-counter');
        var maxChars = $container.data('max-chars');

        $input.on('input',function () {
            if (maxChars && $input.val().length > maxChars) {
                $input.val($input.val().slice(0, maxChars)).trigger('input');
            }
            $counter.empty().append(
                $('<span>', {
                    text: $input.val().length
                }),
                maxChars ? ('/' + maxChars) : ''
            );
        });

        $input.trigger('input');
    });

    $('.js-spoiler').each(function () {
        var $container = $(this);
        var $toggle = $container.find('.js-spoiler-toggle');
        var $content = $container.find('.js-spoiler-content');

        $toggle.on('click', function () {
            $toggle.toggleClass('open');
            $content.css({
                'min-height': ($toggle.hasClass('open') ? $content.get(0).scrollHeight : '')
            });
        });
    });

    $('.js-header-menu-item, .js-footer-menu-item').on('click', function () {
        $(this).toggleClass('open').siblings().removeClass('open');
    });

    $('.js-header').each(function (index, el) {
        var $header = $(el);

        var updateHeaderPosition = function () {
            if (window.innerWidth < document.body.clientWidth) {
                $header.css({
                    'width': document.body.scrollWidth,
                    'transform': 'translateX(' + (-1 * window.pageXOffset) + 'px)'
                });
            } else {
                $header.css({
                    'width': '',
                    'transform': ''
                });
            }
        };

        $(window).on('resize scroll', function () {
            updateHeaderPosition();
        });

        updateHeaderPosition();
    });

    /**
     * Клик по кнопке открытия попапа
     */
    $(document).on('click', '.js-popup-open', function () {
        var popupSelector = $(this).data('target');

        // Если попап присутствует на странице
        if ($(popupSelector).length) {
            var $target = $(popupSelector).clone();
            $target.appendTo('body').addClass('active');

            // Закрыть попап и снять обработчики событий
            var closePopup = function () {
                $target.remove();
                $(document).off('.popup');
            };

            // Закрытие попапа с клавиатуры
            $(document).on('keydown.popup', function (e) {
                if (e.key === 'Escape' && $target.hasClass('active')) {
                    closePopup();
                }
            });

            // Закрытие попапа по клику на оверлей или кнопку закрытия
            $target.on('click.popup', function (e) {
                if ($(e.target).hasClass('js-popup-close') || $(e.target).hasClass('js-popup-overlay')) {
                    closePopup();
                }
            });
        }
    });

    var $phoneFields = $('.js-phone-mask');

    if ($phoneFields.length) {

        $phoneFields.inputmask('+[999999999999999]', {
           placeholder: '',
        });
    }

    var closeAllItemsProjectSubmenu = function () {
        $('.js-project-submenu').each(function () {
            $(this).removeClass('is-open');
        })
    }

    $(document).on('click', '.js-project-submenu', function (event) {
        if ($(event.target).is('.js-project-submenu > .js-menu-value')) {
            var $target = $(event.target).closest('.js-project-submenu');
            if ($target.hasClass('is-open')) {
                closeAllItemsProjectSubmenu();
            } else {
                closeAllItemsProjectSubmenu();
                $target.addClass('is-open');
            }
        }
    });

    // запрет вставки
    $(document).on('paste', '.js-disable-paste', function(e) {
        e.preventDefault();
    });

    // инициализация попапов
    popup();

    $('.js-marquee').marquee({
        duration: 9000,
        gap: 10,
        delayBeforeStart: 0,
        direction: 'left',
        duplicated: true,
    });

    $('.js-feedback-form').each(function(index, item) {
        simpleForm($(item));
    });

    $(document).on('click', '.js-detail-popup-handle', function (evt) {
        if (evt.currentTarget === 'undefined') {
            return;
        }
        popupDetail($(evt.currentTarget));
    });

    $('.js-tournament-select').on('change', function () {
        $('.js-tournament-form').find('form').trigger('submit');
    });
});
